import React from "react";
import {
  DatePicker,
  FileSchema,
  NumberSchema,
  TextSchema,
} from "../InputSchema";

const IdentitySchemaInput = ({
  schemaProps,
  handleChangeFields,
  handlePic,
  requiredFields,
  handleDatePicker,
}) => {
  return (
    <form>
      <div className="row m-0">
        {schemaProps &&
          Object.entries(schemaProps).map(([key, value]) => {
            if (key === "dob") {
              return (
                <div className="col-md-6" key={key}>
                  <DatePicker
                    selected={value}
                    onChange={(value, ev) => {
                      handleDatePicker(key, value, ev);
                    }}
                    name={key}
                    label={key}
                    required={requiredFields.includes(key)}
                  />
                </div>
              );
            } else if (key === "gender") {
              return (
                <div className="form-group  col-md-6" key={key}>
                  <label className="outer-text outer-textlab ">
                    {key}
                    {requiredFields.includes(key) ? (
                      <span className="text-danger">*</span>
                    ) : null}
                  </label>
                  <div className="row mt-2 mx-0">
                    <div className="form-check col-md-3 me-4">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="male"
                        value="male"
                        name={key}
                        checked={value === "male"}
                        onChange={handleChangeFields}
                      />
                      <label
                        className="form-check-label formchecklab"
                        htmlFor="male"
                      >
                        Male
                      </label>
                    </div>
                    <div className=" form-check  col-md-3">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="female"
                        value="female"
                        name={key}
                        checked={value === "female"}
                        onChange={handleChangeFields}
                      />
                      <label
                        className="form-check-label formchecklab"
                        htmlFor="female"
                      >
                        Female
                      </label>
                    </div>
                  </div>
                </div>
              );
            } else if (key === "mobile") {
              return (
                <div className="col-md-6" key={key}>
                  <NumberSchema
                    label={key}
                    textValue={value}
                    name={key}
                    onTextInputChange={handleChangeFields}
                    placeholderValue={"Enter " + key}
                    required={requiredFields.includes(key)}
                  />
                </div>
              );
            } else if (key === "photo") {
              return (
                <div className="col-md-6" key={key}>
                  <FileSchema
                    label={key}
                    onFileChange={handlePic}
                    required={requiredFields.includes(key)}
                    name={key}
                    accept={"image/*"}
                  />
                </div>
              );
            } else {
              return (
                <div className="col-md-6" key={key}>
                  <TextSchema
                    label={key}
                    textValue={value}
                    name={key}
                    onTextInputChange={handleChangeFields}
                    placeholderValue={"Enter " + key}
                    required={requiredFields.includes(key)}
                  />
                </div>
              );
            }
          })}
      </div>
    </form>
  );
};

export default IdentitySchemaInput;
